import Effects from 'effects/Effects.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';

export default class PhaseShiftAllpass extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Phase Shift Allpass", () => new Tone.Gain(1), sequencerEngine);

        const allpassBank1Values = [0.6923878, 0.9360654322959, 0.9882295226860, 0.9987488452737];
	const allpassBank2Values = [0.4021921162426, 0.8561710882420, 0.9722909545651, 0.9952884791278];
        
	this._bank0 = this._createAllPassFilterBank(allpassBank1Values);
	this._bank1 = this._createAllPassFilterBank(allpassBank2Values);
	this._oneSampleDelay = Tone.context.createIIRFilter([0.0, 1.0], [1.0, 0.0]);

        this.output = new Tone.Gain(1);
        this.offset90 = new Tone.Gain(1);

        this.effectNode.chain(... this._bank0, this._oneSampleDelay, this.output);
        this.effectNode.chain(... this._bank1, this.offset90);
    }

    connect(x) {
        this.output.connect(x);
    }

    disconnect(x) {
        this.output.disconnect(x);
    }

    _createAllPassFilterBank(bankValues) {
	return bankValues.map(value => {
	    const coefficients = [[value * value, 0, -1], [1, 0, -(value * value)]];
	    return Tone.context.createIIRFilter(coefficients[0], coefficients[1]);
	});
    }
}

